import { render, staticRenderFns } from "./ItemFilters.vue?vue&type=template&id=86603f32&scoped=true"
import script from "./ItemFilters.vue?vue&type=script&lang=ts"
export * from "./ItemFilters.vue?vue&type=script&lang=ts"
import style0 from "./ItemFilters.vue?vue&type=style&index=0&id=86603f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86603f32",
  null
  
)

export default component.exports